import styled from "styled-components";

export const SignUpContainer = styled.div`
display: flex;
flex-direction: column;
width: 45%;
min-width: 400px;
align-items: center;
h2 {
    margin: 10px 0;
}
p{
    margin: 10px 0 30px;
    color: rgb(255, 99, 125);
    font-weight: 800;
}
`
export const BtnsContainer = styled.div`
display: flex;
flex-wrap: wrap;
justify-content: center;
`


